module.exports = __webpack_public_path__ + "static/media/wristband_coordination.3d6fb16e.png";